export default "__VITE_ASSET__D_jHXF2P__"